// Search and Sort for the cattle and sheep daily lists (R17), shared because the
// two lists are one ruminant pattern (A01). Pure: each takes the rows already
// loaded and returns a view of them; nothing here reads or writes.

/**
 * Search (L02) as a filter: a case-insensitive substring match over the text
 * fields the caller names for a row. An empty query matches every row.
 */
export function matchesDailySearch(fields: readonly unknown[], query: string): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return fields.some((v) =>
    String(v ?? '')
      .toLowerCase()
      .includes(q),
  );
}

/**
 * Sort that keeps the R21 day grouping. DailyCardList groups CONSECUTIVE
 * same-day rows, so a free column sort would split one day into many headers;
 * here the rows always run by day (newest or oldest first) and only the order
 * within a day is chosen. Ties keep the loaded order (a stable sort).
 *
 * The default (`desc` + `loaded`) returns the rows untouched, so the list reads
 * exactly as it did before the control existed.
 */
export function sortDailyRowsByDay<Row extends {date?: string | null}>(
  rows: readonly Row[],
  dir: string,
  within: string,
  groupLabel: (row: Row) => string,
  teamLabel: (row: Row) => string,
): Row[] {
  if (dir !== 'asc' && within !== 'group' && within !== 'team') return rows.slice();
  return rows
    .map((row, index) => ({row, index}))
    .sort((a, b) => {
      const byDay = String(a.row.date || '').localeCompare(String(b.row.date || ''));
      if (byDay) return dir === 'asc' ? byDay : -byDay;
      const inDay =
        within === 'group'
          ? groupLabel(a.row).localeCompare(groupLabel(b.row))
          : within === 'team'
            ? teamLabel(a.row).localeCompare(teamLabel(b.row))
            : 0;
      return inDay || a.index - b.index;
    })
    .map((x) => x.row);
}
